"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ProcessQuestion = ({ question, index, total }) => (core_1.jsx("div", { className: styles_scss_1.default.questionInstance },
    core_1.jsx("div", { className: styles_scss_1.default.number },
        core_1.jsx("strong", null, constants_1.default.patientProgress.detail.questions.questionNumber(index, total))),
    core_1.jsx("div", { className: styles_scss_1.default.question },
        core_1.jsx("span", null, question.wording)),
    core_1.jsx("div", { className: styles_scss_1.default.answer },
        core_1.jsx("span", null, question.answer))));
const ProcessQuestions = ({ patient, processQuestions, pendingPatient, pendingProcessQuestion, match, getPatient, getProcessQuestions }) => {
    var _a;
    const { patientId, contentId } = match.params;
    react_1.useEffect(() => {
        if ((patient === null || patient === void 0 ? void 0 : patient.id) !== patientId) {
            getPatient(patientId);
        }
    }, [patient]);
    react_1.useEffect(() => {
        if (lodash_1.toString(processQuestions === null || processQuestions === void 0 ? void 0 : processQuestions.content_id) !== contentId) {
            getProcessQuestions({ patientId, contentId });
        }
    }, [processQuestions]);
    if (pendingPatient || pendingProcessQuestion)
        return core_1.jsx(components_1.ScreenLoader, null);
    return (core_1.jsx("div", { className: styles_scss_1.default.processQuestionsLayout },
        core_1.jsx(components_1.Meta, { title: constants_1.default.patientProgress.detail.questions.helmetTitle, removeViewport: true }),
        core_1.jsx(components_1.Paper, { className: styles_scss_1.default.container },
            core_1.jsx(components_1.Link, { to: constants_1.Routes.PatientProgressDetail.replace(':accountId', patient === null || patient === void 0 ? void 0 : patient.id) },
                core_1.jsx(components_1.Button, { className: styles_scss_1.default.goBackButton, variant: "transparent", title: constants_1.default.patientProgress.detail.questions.backToProgressList, ariaLabel: constants_1.default.patientProgress.detail.questions.backToProgressList, imgUrls: { default: constants_1.Images.arrowLeftGreen, selected: constants_1.Images.arrowLeftGreen } })),
            core_1.jsx("div", { className: styles_scss_1.default.header },
                core_1.jsx("h2", null, constants_1.default.patientProgress.detail.questions.title(patient === null || patient === void 0 ? void 0 : patient.firstName))),
            core_1.jsx("div", { className: styles_scss_1.default.questions }, (_a = processQuestions === null || processQuestions === void 0 ? void 0 : processQuestions.question_set) === null || _a === void 0 ? void 0 : _a.map((question, index) => (core_1.jsx(ProcessQuestion, { question: question, index: index + 1, total: processQuestions.question_set.length })))))));
};
const stateProps = (state) => ({
    patient: selectors_1.default.user.getUserDetail(state),
    processQuestions: selectors_1.default.user.getPatientProcessQuestions(state),
    pendingPatient: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getUser),
    pendingProcessQuestion: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.getPatientProcessQuestion)
});
const dispatchProps = {
    getPatient: (id) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getUserPayload(id)),
    getProcessQuestions: (data) => radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.getPatientProcessQuestion(data))
};
exports.default = react_redux_1.connect(stateProps, dispatchProps)(ProcessQuestions);
